module.exports = __webpack_public_path__ + "img/tousu@2x.37045f4e.png";